import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "loading-wrap",
  ref: "refRoot",
  style: {
    "display": "none"
  }
};

var _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "24px",
  height: "30px",
  viewBox: "0 0 24 30",
  style: {
    "enable-background": "new 0 0 50 50"
  },
  "xml:space": "preserve"
}, [/*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "13",
  width: "4",
  height: "5",
  fill: "#333"
}, [/*#__PURE__*/_createVNode("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/_createVNode("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
})]), /*#__PURE__*/_createVNode("rect", {
  x: "10",
  y: "13",
  width: "4",
  height: "5",
  fill: "#333"
}, [/*#__PURE__*/_createVNode("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/_createVNode("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
})]), /*#__PURE__*/_createVNode("rect", {
  x: "20",
  y: "13",
  width: "4",
  height: "5",
  fill: "#333"
}, [/*#__PURE__*/_createVNode("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/_createVNode("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
})])], -1);

var _hoisted_3 = {
  class: "loading-wrap_text",
  ref: "refLoadingWrapText"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_hoisted_2, _createVNode("div", _hoisted_3, null, 512)], 512);
}